export default __webpack_public_path__ + "static/media/ShawnaeLovelace.41a88838.png";